import { TransientShapeLayerState } from '../../../../core/outputs/annotation/annotation-shared/state/layers/transient-shape-layer-state';

export class TransientMeshLayerState extends TransientShapeLayerState {
  sideViewsExpanded = true;
}
